function localStorageAvailable() {
  try {
    const x = 'storage_test';
    localStorage.setItem(x, x);
    localStorage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

function clearLocalStorage() {
  if (localStorageAvailable()) {
    const viewValues = [];

    Object.keys(localStorage).forEach((key) => {
      if (key.includes('liveSessions')) {
        viewValues.push({ key, value: localStorage[key] });
      }
    });
    localStorage?.clear();
    viewValues.forEach(({ key, value }) => localStorage.setItem(key, value));
  }
}

export { localStorageAvailable, clearLocalStorage };
